class PrintRoutesController {
    /*@ngInject*/
    constructor($state, $stateParams, User, ShipmentService, $location) {
        this.ShipmentService = ShipmentService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.User = User;
        this.routesInfo = []
        this.title = '';
        this.vaultDate = '';
        this.routeId = '';
        this.timezone = '';
        this.totals = [];
        this.routeDetails = [];
    }

    $onInit() {
        let printData = undefined;
        
        // First check URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('data')) {
            try {
                printData = {
                    data: JSON.parse(decodeURIComponent(urlParams.get('data'))),
                    title: decodeURIComponent(urlParams.get('title') || ''),
                    vaultDate: decodeURIComponent(urlParams.get('vaultDate') || ''),
                    routeId: decodeURIComponent(urlParams.get('routeId') || ''),
                    flag: decodeURIComponent(urlParams.get('flag') || ''),
                    timezone: decodeURIComponent(urlParams.get('timezone') || ''),
                    totals: JSON.parse(decodeURIComponent(urlParams.get('totals') || '{}')),
                    routeDetails: JSON.parse(decodeURIComponent(urlParams.get('routeDetails') || '{}'))
                };
            } catch (e) {
                console.error('Error parsing URL parameters:', e);
            }
        }
        
        // If no URL data, try window.opener
        if (!printData && window.opener && window.opener.w && window.opener.w.printData) {
            printData = window.opener.w.printData;
        }

        if (printData) {
            this.routesInfo = printData.data;
            this.title = printData.title;
            this.vaultDate = printData.vaultDate;
            this.routeId = printData.routeId;
            this.flag = printData.flag;
            this.timezone = printData.timezone;
            this.logoBase64 = printData.logoBase64 || null;
            this.totals = printData.totals;
            this.routeDetails = printData.routeDetails;
        }
       
        if(window.opener && window.opener.w && window.opener.w.printData && !window.opener.w.printData.email) {      
            setTimeout(() => {
                window.print()
            }, 1000)
        }
    }
}

export default PrintRoutesController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/routes/print/print_routes.controller.js